import React from "react";
import { ChevronDown } from "lucide-react";

const Select = ({ value, onChange, options, placeholder, className = "", ...props }) => {
  return (
    <div className="relative">
      <select
        value={value}
        onChange={onChange}
        className={`w-full px-4 py-2 bg-slate-100 border border-slate-200 rounded-lg text-text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent appearance-none ${className}`}
        {...props}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none text-slate-500">
        <ChevronDown size={16} />
      </div>
    </div>
  );
};

export default Select;
